<template>
    <hts-drawer
        v-model="visible"
        color="main"
        size="large"
        :title="$t('labels.viewMovement')"
        @close="close">
        <hts-map-movement
            ref="movement"
            :last24h-positions="positions"
            :center-position="centerPosition" />
    </hts-drawer>
</template>

<script setup lang="ts">
const visible = ref(false)
const positions = ref<Array<any> | null>([])

const open = (item: any) => {
  positions.value = item?.last24hPath?.locations
  visible.value = true
}

const centerPosition = computed(() => {
  if (!positions || !positions.value || !positions.value.length) {
    return {
      lat: 10.7561542,
      lng: 106.6896784
    }
  }

  return positions.value[0]
})

const loadRoute = (last24hPath: any) => {
  if (!last24hPath) {
    process.client && $toast().error('Chưa có lịch sử di chuyển')
    return
  }

  const { locations } = last24hPath

  if (!locations || !Array.isArray(locations) || !locations.length) {
    process.client && $toast().error('Chưa có lịch sử di chuyển')
    return
  }

  return ''
}

const close = () => {
  positions.value = null
  visible.value = false
}

defineExpose({
  open
})
</script>
